registerComponent("modals/modal-videos-youtube-redesign", function (component) {
/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} component - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $component          = $(component);
const $wrapper     = $component.find('.modal-videos-wrapper');
const $player      = $component.find('.player');
const $btnplay     = $('[data-play-ytb-modal]');
const $btnClose    = $component.find('.btn-close');

let isOpened = false;

let player;

const removerAcentos = (str) => {
    var w,
        map = {
            a: /[\xE0-\xE6]/g,
            e: /[\xE8-\xEB]/g,
            i: /[\xEC-\xEF]/g,
            o: /[\xF2-\xF6]/g,
            u: /[\xF9-\xFC]/g,
            c: /\xE7/g,
            n: /\xF1/g
        };

    str = str.replace(/[?!.,@#$%&()]/g, '');
    str = str.replace(/ +\| +/g, ' ');

    for (w in map) {
        str = str.replace(map[w], w);
    }

    return str;
};

const toSpinal = (str) => removerAcentos(str).split(/\s|_|(?=[A-Z])/).join('-').toLowerCase();

const initPlayer = () => {
    if (typeof player === 'undefined') {
        // O Player é uma facade: nada do YouTube carrega aqui — a IFrame API e o
        // iframe (youtube-nocookie) só são criados no primeiro play()
        player = new Player($player.get(0));

        player.on('ready', function () {
            $component.trigger('player:loaded', [this.videoSlug]);
        });

        player.on('playing', function () {
            $document.trigger('video.playing', [this.videoSlug]);
        });

        player.on('paused', function () {
            $document.trigger('video.paused', [this.videoSlug]);
        });

        player.on('ended', function () {
            $document.trigger('video.ended', [this.videoSlug]);
        });

        player.on('progress:25', function () {
            $document.trigger('video.progress', [this.videoSlug, 25]);
        });

        player.on('progress:50', function () {
            $document.trigger('video.progress', [this.videoSlug, 50]);
        });

        player.on('progress:75', function () {
            $document.trigger('video.progress', [this.videoSlug, 75]);
        });

        player.on('progress:100', function () {
            $document.trigger('video.progress', [this.videoSlug, 100]);
        });
    }
}

const open = (videoId, videoSlug) => {
    initPlayer();

    isOpened = true;

    $body.addClass('modal-opened');

    gsap.set($component, { top: '-100%', display: 'block', opacity: 1 });
    gsap.set($btnClose, { display: 'block', opacity: 0 });
    gsap.set($player, { display: 'block', opacity: 0 });

    // O play() dentro do gesto de clique faz o upgrade da facade (cria o iframe)
    // e inicia o vídeo
    player.setVideo(videoId, videoSlug);
    player.play();

    gsap.to($component, {
        duration: 0.8,
        top: '0%',
        ease: "power2.inOut",
        onComplete() {
            gsap.to($btnClose, { duration: 0.4, opacity: 1 });
            gsap.to($player, { duration: 0.4, opacity: 1 });
        }
    });
};

const close = () => {
    isOpened = false;

    $body.removeClass('modal-opened');

    if (typeof player != 'undefined') {
        player.pause();
    }

    gsap.to($component, {
        duration: 0.8,
        top: '100%',
        ease: "power2.inOut",
        onComplete() {
            gsap.set($component, { display: 'none' });
        }
    });
};

$component.on('modal:open', function (e, videoId, videoSlug) {
    open(videoId, videoSlug);
});

$component.on('modal:close', function () {
    close();
});

$btnClose.on('click', function () {
    close();
});

$btnplay.on('click', function() {
    const $this = $(this);

    if($this.data('modal-format')) {
        $wrapper.addClass($this.data('modal-format'));
    } else {
        $wrapper.removeClass('vert');
    }

    const videoID   = $(this).data('play-ytb-modal');

    let titleVideo = $(this).data('title-video');
    if(typeof titleVideo !== 'undefined') {
        titleVideo = toSpinal(titleVideo);
    }

    open(videoID, titleVideo);
});

$document.on('keyup', function (e) {
    if (isOpened && e.key === 'Escape') {
        close();
    }
});

});
